import { entityRegistry } from '@app/icare/entities/registry'
import { createQueryStore, QueryBaseSchema } from '@pkg/api/query'
import { EntityIndexPage } from '@pkg/ui/layout/EntityIndexPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/pflegeheime/')({
  component: RouteComponent,
})

const filter = createQueryStore({
  schema: entityRegistry.nursingHome.search.filterSchema ?? QueryBaseSchema,
})

function RouteComponent() {
  return <EntityIndexPage entityName="nursingHome" queryStore={filter} />
}
